// Configuración del modo offline. ÚNICO lugar donde se define a qué URL se hace el heartbeat.
const API = process.env.VUE_APP_ROOT_API;

export const HEARTBEAT = {
  // Ítem 14 (ping_resultado.md): GET /api/ping, público, sin base de datos y sin caché, fuera de throttle:api.
  // Sin token: no hay preflight OPTIONS y un 401 ya no marca la sesión vencida (D1: la marcan el sync, la venta
  // online y el cierre con su propio 401). Antes:
  // // Etapa 7: cambiar a `${API}/ping` (público) y poner conAuth: false
  // url: `${API}/caja/verificar`,
  // conAuth: true,
  url: `${API}/ping`,
  conAuth: false,
  intervaloMs: 30000,               // pestaña visible
  intervaloSegundoPlanoMs: 120000,  // pestaña oculta (null = pausar hasta que vuelva a estar visible)
  timeoutMs: 5000,
  fallosParaOffline: 3,
  exitosParaOnline: 1,
  // Únicos HTTP que cuentan como fallo (proxy sin backend). 401, 403, 404 y 500 son «servidor alcanzable».
  statusDeFallo: [502, 503, 504],
};

export const MENSAJE_BLOQUEO_OFFLINE = 'No disponible sin conexión';

// Etapa 3A: catálogo local del POS
export const CATALOGO = {
  horasVigencia: 4,      // más viejo que esto se refresca al entrar al POS (si hay red)
  timeoutMs: 20000,      // /pos/catalogo calcula recetas producto por producto: puede tardar
  // Ítem 20 (ticket_local_resultado.md): la fila lleva ahora `encabezado_ticket`; el catálogo viejo se ignora y, con red, se vuelve a
  // descargar. Antes:
  // versionApp: 1,         // formato de la fila; si cambia, el caché viejo se ignora
  versionApp: 2,         // formato de la fila; si cambia, el caché viejo se ignora
};

// Etapa 3B: venta online
export const VENTA_ONLINE = {
  timeoutMs: 15000, // D8: sin respuesta en este tiempo, la venta queda en la cola (el uuid evita duplicarla)
  // D3: los 409 traen `codigo`; el mensaje solo se usa de respaldo si una respuesta no lo trae
  codigoDuplicada: 'venta_duplicada',
  codigoCajaCerrada: 'caja_cerrada',
  mensajeDuplicada: 'Esta venta ya fue sincronizada anteriormente',
  mensajeCajaCerrada: 'La caja ya fue cerrada, no se pueden registrar más ventas',
};

// Etapa 3C: sincronización de la cola
export const SYNC = {
  loteMax: 50,                 // MAX_VENTAS_POR_LOTE del backend
  timeoutLoteMs: 30000,
  backoffBaseMs: 5000,         // 5 s, 10 s, 20 s, … con ±20 % de variación
  backoffMaxMs: 300000,        // tope: cada 5 min
  diasPurga: 7,
  candadoMs: 60000,            // caducidad del candado de respaldo entre pestañas
};

// Etapa 3D: avisos de la cola y del reloj
export const AVISOS = {
  horasVentaAntigua: 60,         // aviso fuerte (el servidor rechaza a las 72 h)
  horasLimiteServidor: 72,       // /ventas/sync rechaza fecha_venta_cliente con más de 3 días
  refrescoEdadMs: 300000,        // la edad de la cola se recalcula cada 5 min aunque la cola no cambie
  desfaseRelojMaxMs: 120000,     // aviso si el reloj difiere más de 2 min (el servidor tolera 5 min hacia el futuro)
  desfaseMinCorreccionMs: 30000, // D3: solo se corrige la fecha con el equipo adelantado 30 s o más
  rttMaxMedicionMs: 3000,        // una medición del reloj con más latencia se descarta
  saltoRelojMs: 60000,           // si la hora del equipo salta más que esto, el desfase medido deja de valer
};

// Etapa 4: cierre de caja con ventas en la cola local
export const CIERRE = {
  esperaEnvioMs: 60000,   // D4: hasta 60 s intentando enviar las ventas de la caja antes de decidir
  timeoutMs: 30000,       // POST /caja/sync y GET /caja/{id}
  progresoMs: 1000,       // refresco del texto «Enviando ventas… (k de n)»
};
